import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../../store/global-store'
import type { LiveChat } from '../../../../types/lives/live'
import type { MessageUserLevelUp } from '../../../../types/lives/messages'

const LIVE_CHAT = '/LIVE-CHAT'
const LIVE_USERS_LEVELS = '/LIVE-USERS-LEVELS'

export function useMessages() {
  const { liveId, addMessageChatLive } = useGlobalStore(
    useShallow((state) => ({
      liveId: state.liveId,
      addMessageChatLive: state.addMessageChatLive,
    })),
  )

  useSub<LiveChat>({
    endpoint: `${LIVE_CHAT}/${liveId}`,
    skip: !liveId,
    onData: addMessageChatLive,
  })

  useSub<LiveChat>({
    endpoint: `${LIVE_CHAT}/br`,
    skip: !liveId,
    onData: addMessageChatLive,
  })

  const formatMessageLevelUp = useCallback(
    (message: string, userId: number) => {
      const id = String(Date.now())

      const themeColorOne = `${'#4568DC'}80`
      const themeColorTwo = `${'#3B4781'}80`

      return {
        id,
        isInvisible: false,
        colors: {
          default: [themeColorOne, themeColorTwo],
          'level-up': [themeColorOne, themeColorTwo],
          earned: [themeColorOne, themeColorTwo],
          sent: [themeColorOne, themeColorTwo],
        },
        message: {
          message,
          userId,
          type: 'earned',
          userSentId: userId,
        },
      }
    },
    [],
  )

  // global
  useSub<MessageUserLevelUp>({
    endpoint: `${LIVE_USERS_LEVELS}`,
    skip: !liveId,
    onData: (data) => {
      addMessageChatLive(formatMessageLevelUp(data?.message, data?.userId))
    },
  })

  // local
  useSub<MessageUserLevelUp>({
    endpoint: `${LIVE_USERS_LEVELS}/${liveId}`,
    skip: !liveId,
    onData: (data) => {
      addMessageChatLive(formatMessageLevelUp(data?.message, data?.userId))
    },
  })
}
